import { TrendingUp } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { getThemeClasses } from '../../utils/theme';

const StatCard = ({ title, value, subtitle, icon: Icon, trend, color = 'blue' }) => {
  const { isDarkMode } = useTheme();
  const theme = getThemeClasses(isDarkMode);

  const colors = {
    blue: isDarkMode ? 'text-blue-400' : 'text-blue-600',
    green: isDarkMode ? 'text-green-400' : 'text-green-600',
    amber: isDarkMode ? 'text-amber-400' : 'text-amber-600',
    red: isDarkMode ? 'text-red-400' : 'text-red-600',
  };

  return (
    <div className={`${theme.card} rounded-xl p-5 border shadow-sm`}>
      <div className="flex items-start justify-between">
        <div>
          <p className={`text-sm ${theme.textTertiary} font-medium`}>{title}</p>
          <p className={`text-2xl font-bold ${theme.textPrimary} mt-1`}>{value}</p>
          {subtitle && <p className={`text-xs ${theme.textMuted} mt-1`}>{subtitle}</p>}
        </div>
        {Icon && (
          <div className={`p-2 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-50'}`}>
            <Icon className={`w-5 h-5 ${colors[color]}`} />
          </div>
        )}
      </div>
      {trend && (
        <div className="flex items-center gap-1 mt-3 text-xs">
          <TrendingUp className="w-3 h-3 text-green-500" />
          <span className="text-green-500 font-medium">{trend}</span>
        </div>
      )}
    </div>
  );
};

export default StatCard;
